import { html } from 'lit';
export default () => {
    return html `<slot name="image"></slot><slot name="meta"></slot><slot name="heading"></slot><slot name="content"></slot><slot></slot>`;
};
//# sourceMappingURL=content-block.js.map